import { COBROWSE_SESSION_TTL_MS } from '~/app/cobrowse/protocol';
import { useAuthStore } from '~/stores/authStore';
import { useCobrowseStore } from '~/stores/cobrowseStore';

declare global {
    interface Window {
        __cobrowse?: { request: (sessionId: string, agentName?: string) => void; leave: () => void };
    }
}

export default defineNuxtPlugin(() => {
    const cobrowse = useCobrowseStore();

    if (useRuntimeConfig().public.appEnv === 'production') {
        return;
    }

    window.__cobrowse = {
        request: (sessionId, agentName = 'Sales (dev)') =>
            cobrowse.receiveRequest({
                sessionId,
                agentName,
                userId: String(useAuthStore().authed?.getId()),
                expiresAt: Date.now() + COBROWSE_SESSION_TTL_MS,
            }),
        leave: () => cobrowse.leave(),
    };
});
